export default __webpack_public_path__ + "e0c62675885ac63194a82873902323c9.png";